import { Event } from '@/js/utils/EventBus/Event';

export enum Events {
    // Define event names here
    OnAction = 'OnAction',
    ChecklistIframeHeight = 'checklistsIframeHeight',
    ChecklistChanged = 'checklistChanged',
    ArmyCandidateCreated = 'armyCandidateCreated',
    NewEditorContentLoaded = 'newEditorContentLoaded',
    NewEditorChanged = 'newEditorChanged',
    JobClassification = 'jobClassification',
    RequestEditorApprovers = 'requestEditorApprovers',
    ShowApprovalRequest = 'ShowApprovalRequest',
    CloseApprovalRequest = 'CloseApprovalRequest',
    EJobs = 'eJobs',
    Expats = 'expats',
    OpenNewTaskDialog = 'OpenNewTaskDialog',
    CloseNewTaskDialog = 'CloseNewTaskDialog',
    OpenEditTaskDialog = 'OpenEditTaskDialog',
    CloseEditTaskDialog = 'CloseEditTaskDialog',
    OpenTaskAutomationDialog = 'OpenTaskAutomationDialog',
    CloseTaskAutomationDialog = 'CloseTaskAutomationDialog',
    CloseOnboardingDialog = 'CloseOnboardingDialog',
}

export const EventBus = {
    // Register events here
    [Events.OnAction]: new Event<{
        props: Record<string, any>;
        data: {
            action: string;
            [key: string]: any;
        };
    }>(),
    [Events.ChecklistIframeHeight]: new Event<{
        height: number;
    }>(),
    [Events.ChecklistChanged]: new Event<{
        checklistId: number;
    }>(),
    [Events.ArmyCandidateCreated]: new Event<{
        status: string;
        message: string;
    }>(),
    [Events.NewEditorChanged]: new Event<{
        message: string;
    }>(),
    [Events.NewEditorContentLoaded]: new Event<{
        message: string;
    }>(),
    [Events.JobClassification]: new Event<{
        type: string;
        id?: string;
        name?: string;
        securedId?: string;
        jobId?: number;
        employeeId?: number;
        href?: string;
    }>(),
    [Events.RequestEditorApprovers]: new Event<{
        type: string;
        securedId?: string;
        jobId?: number;
        approversNames: string[];
        approversIds: number[];
        createApprovalRequest?: boolean;
    }>(),
    [Events.ShowApprovalRequest]: new Event<{
        approvalRequestId: number;
        substitudedEmployeeId?: number;
    }>(),
    [Events.CloseApprovalRequest]: new Event<{
        approvalRequestId: number;
    }>(),
    [Events.EJobs]: new Event<{
        type: string;
    }>(),
    [Events.Expats]: new Event<{
        type: string;
    }>(),
    [Events.OpenNewTaskDialog]: new Event<{
        answerIds: number[];
        userIds: number[];
        employeeIds?: number[];
        checkedTaskTypes?: string[];
    }>(),
    [Events.CloseNewTaskDialog]: new Event<Record<string, never>>(),
    [Events.OpenEditTaskDialog]: new Event<{
        taskId: number;
    }>(),
    [Events.CloseEditTaskDialog]: new Event<Record<string, never>>(),
    [Events.OpenTaskAutomationDialog]:  new Event<{
        offerId: number;
    }>(),
    [Events.CloseTaskAutomationDialog]: new Event(),
    [Events.CloseOnboardingDialog]: new Event<{
        success: boolean,
    }>(),
};
